import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcSummaryShape, userIdentityShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import ModalActions from 'app/actions/ModalActions';

import SummaryDisplay from './SummaryDisplay';

export class SummaryDisplayContainer extends React.PureComponent {
  render() {
    return <SummaryDisplay {...this.props} />;
  }
}

SummaryDisplayContainer.propTypes = {
  // ownProps
  summary: ugcSummaryShape.isRequired,
  displayStaffBadge: PropTypes.bool,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,

  // Redux props
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapStateToProps = state => ({
  users: selectUserEntities(state)
});

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SummaryDisplayContainer);
